export default {
    setAircraft(state, aircraft) {
        state.aircraft = aircraft;
    },
    setActiveAircraft(state, activeAircraft) {
        state.activeAircraft = activeAircraft;
    },
}